import { Timeline } from "antd";
import { useMemo } from "react";
import MarkdownRenderer from "./MarkdownRenderer";
import { createUseStyles } from "react-jss";
import { formatDate } from "../utils/common";

const useStyles = createUseStyles({
  summary: {
    padding: "0px 20px",
  },
  timeline: {
    display: "flex",
    marginTop: "25px",
  },
});

export interface ITrackingTimelineEvents {
  timeStamp: string;
  message: string;
}

const TrackingTimeline: React.FC<{
  summary: string;
  events: ITrackingTimelineEvents[];
}> = ({ summary, events = [] }) => {
  const classes = useStyles();

  const items = useMemo(() => {
    return events
      .filter(d => d.timeStamp && d.message)
      .map(d => ({
        label: formatDate(d.timeStamp, "dd MMM yyyy hh:mm a"),
        children: d.message,
      }));
  }, [events]);

  return (
    <div>
      {summary ? (
        <div className={classes.summary}>
          <MarkdownRenderer markdown={summary} />
        </div>
      ) : null}
      <div className={classes.timeline}>
        <Timeline mode="left" items={items}></Timeline>
      </div>
    </div>
  );
};

export default TrackingTimeline;
